import { render, staticRenderFns } from "./AddMemberToOrganisation.vue?vue&type=template&id=08fc7284"
import script from "./AddMemberToOrganisation.vue?vue&type=script&lang=ts"
export * from "./AddMemberToOrganisation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports